// @flow
import * as React from 'react';
import { ThemeProvider, ToastProvider } from '@locus-taxy/neo-ui';
import { Config } from '@researchgate/react-intersection-observer';
import 'react-dates/initialize';

// eslint-disable-next-line no-unused-vars
Config.errorReporter = function (errorMsg) {
    // ES-46834: Disable temporarily
    // ErrorReporter.notify(errorMsg);
};

type Props = {
    children: React.Node
};

const CommonProvider = ({ children }: Props): React.Node => {
    // Neo version can be different in common and mfe app
    // Wrapping the app with provider from the common's version of neo
    return (
        <ThemeProvider>
            <ToastProvider>{children}</ToastProvider>
        </ThemeProvider>
    );
};

export { CommonProvider };
